import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { NavbarUserModule } from '@fantaz/shared/layout/navbar-user';
import { SharedUiColorSchemeSwitcherModule } from '@fantaz/shared/ui/color-scheme-switcher';
import { SharedUiModalAlertModule } from '@fantaz/shared/ui/modal-alert';
import { SharedUiPromoteCodeModalModule } from '@fantaz/shared/ui/promote-code-modal';
import { NavbarComponent } from './navbar.component';
import { MaterialModule } from '@fantaz/shared/ui/material';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    NavbarUserModule,
    RouterModule,
    SharedUiModalAlertModule,
    SharedUiPromoteCodeModalModule,
    SharedUiColorSchemeSwitcherModule,
  ],
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
})
export class NavbarModule {}
